import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllStudents as apiFn } from "../../api/apiStudents";
import { useSnackbar } from "notistack"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useForceDeleteAllStudents() { const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: forceDeleteAllStudents, isPending: isForceDelete } = useMutation({ mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["students"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { forceDeleteAllStudents, isForceDelete }; }
